/* 曹操傳・第 2 章：汴水之敗（初平元年，190）
 * 史實：《三國志·武帝紀》「太祖到汴水，遇卓將徐榮，與戰不利，士卒死傷甚多。太祖爲流矢所中，所乘馬被創，從弟洪以馬與太祖，得夜遁去。」
 *       《曹洪傳》：洪曰「天下可無洪，不可無君」。
 * 流程：曹操帶兵西進追董卓，在汴水遇徐榮伏兵，邊打邊退 → 曹操中箭、戰馬受傷，改操作曹洪：把馬讓給曹操，
 *       護著他在夜裡撤到汴水邊 → 沿河岸找船（三處渡口只有一處有船）→ 兩人都上船即勝利。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, swapPlayer, TROOPS, PEOPLE, rout } from '../kit.ts';
import { AMBUSH, BANKS } from '../maps/bianshui.ts';

const LV = 5, START = [1200, 2500];
const FOE = { spec: TROOPS.dong, name: '涼州兵', hp: 380, maxHp: 380, atk: 22, ms: 245 };

export default {
  id: 'caocao-2', map: 'bianshui', hero: 'caocao',
  title: '第 2 章　汴水之敗', year: '初平元年（190）',
  brief: {
    quote: [{ text: '太祖到汴水，遇卓將徐榮，與戰不利，士卒死傷甚多。', src: '《三國志·魏書·武帝紀》' }],
    text: '關東諸侯起兵討董卓，卻各自屯兵、置酒高會，不肯進取。董卓焚燒洛陽、挾天子西遷，曹操獨自引兵西進追擊。',
    goals: ['追擊董卓', '（遇伏）護著曹操撤到汴水邊', '沿河岸找到渡船'],
  },
  words: { ally: '曹軍', foe: '涼州兵' },
  stars: [
    { text: '撤退時曹操沒有再受傷', ok: (m) => !m.vars.hitAfter },
    { text: '換成曹洪後 90 秒內找到渡船', ok: (m) => m.vars.boatT != null && m.vars.boatT < 90 },
    { text: '曹軍折損不超過 4 人', ok: (m) => m.stats.lost <= 4 },
  ],
  steps: [
    { // 1. 西進追擊，遇伏
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0]; me.y = START[1];
        V.men = Array.from({ length: 8 }, (_, i) => { const u = m.recruit(me.x - 80 - (i % 4) * 50, me.y - 60 + Math.floor(i / 4) * 90, '曹軍'); u.spec = TROOPS.wei; m.join(u, me); return u; });
        V.hong = ally(w, 'caohong', me.x - 140, me.y + 120, LV);
        m.line('曹操', '諸君不肯進，那就我一軍西進！董卓燒了洛陽，正該乘勝追擊！');
        m.obj('chase', '西進追擊董卓');
        m.mark('west', AMBUSH[0], AMBUSH[1], '汴水');
      },
      tick(m, w) { return m.near(w.player, AMBUSH[0], AMBUSH[1], 400); },
    },
    { // 2. 遇伏：邊打邊退
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('chase'); m.unmark('west');
        m.big('中伏！');
        m.card('遇卓將徐榮，與戰不利，士卒死傷甚多。', '《武帝紀》');
        V.foes = [];
        for (const [cx, cy] of [[AMBUSH[0] - 200, AMBUSH[1] - 700], [AMBUSH[0] + 300, AMBUSH[1] + 700], [AMBUSH[0] - 900, AMBUSH[1]]]) for (let i = 0; i < 7; i++) V.foes.push(m.foe('huangjin', cx + (i % 4) * 80, cy + Math.floor(i / 4) * 90, FOE));
        V.xu = boss(w, PEOPLE.xurong, AMBUSH[0] - 1100, AMBUSH[1], { name: '徐榮', hp: 5000, atk: 66, armor: 8, ms: 230 });
        m.line('曹操', '有埋伏！往東退，退回汴水！');
        m.obj('back', '邊打邊退');
        V.t2 = w.t;
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        V.xu.home = [me.x, me.y];
        return w.t - V.t2 > 22 || me.hp < me.maxHp * 0.45;
      },
    },
    { // 3. 曹洪讓馬：改操作曹洪
      enter(m, w) {
        const V = m.vars, cao = w.player, hong = V.hong;
        m.done('back');
        m.card('太祖爲流矢所中，所乘馬被創。', '《武帝紀》');
        cao.hp = Math.max(cao.hp, cao.maxHp * 0.5);
        if (!hong.alive) { hong.alive = true; hong.hp = hong.maxHp * 0.6; }
        hong.x = cao.x + 60; hong.y = cao.y + 40;
        swapPlayer(w, hong);
        V.cao = cao;
        w.addBuff(cao, { id: '中箭', t: 9999, neg: true, atkP: -0.5 }); w.addBuff(cao, { id: '曹洪的馬', t: 9999, ms: 0.15 }); // 騎上曹洪的馬：跑得比追兵快
        for (const u of m.alive(V.men)) m.join(u, hong);
        m.after(1.5, () => m.line('曹洪', '主公，騎我的馬走！'));
        m.after(3.5, () => m.line('曹操', '那你呢？'));
        m.after(5.5, () => m.line('曹洪', '天下可無洪，不可無君！'));
        m.after(9, () => m.line('提示', '現在操作曹洪：護著曹操往東撤到汴水邊，沿河岸找渡船（三處渡口只有一處有船）。'));
        V.boatAt = Math.floor(SG.rand() * 3);
        BANKS.forEach(([x, y], i) => m.mark('b' + i, x - 100, y, '渡口？', true));
        m.obj('boat', '護著曹操，沿汴水找渡船');
        V.t3 = w.t; V.caoHp = cao.hp;
        // 讓馬的這一下爭到時間：近的追兵被甩開、天黑追得慢
        for (const u of m.alive(V.foes)) { const p = SG.MAP.nearestFree(Math.min(u.x, cao.x) - 900, u.y); u.x = p[0]; u.y = p[1]; u.st.stun = 2; u.ms = 175; u.target = null; u.home = [cao.x, cao.y]; }
        rout(m, w, m.alive(V.foes).slice(6), [800, 2500]); // 天黑：大半的追兵追丟了，只剩六個
        V.xu.home = [1600, 2500]; V.xu.untargetable = true; V.xu.target = null; // 徐榮收兵，只派人追
      },
      tick(m, w) {
        const me = w.player, V = m.vars, cao = V.cao;
        if (cao.hp < V.caoHp - 1) V.hitAfter = true;
        V.caoHp = cao.hp;
        // 追兵：追曹操；徐榮也追
        for (const u of m.alive(V.foes)) if (!(u.target && u.target.alive)) u.home = [cao.x, cao.y];
        // 找船：走到渡口看看
        BANKS.forEach(([x, y], i) => {
          if (V['seen' + i] || !m.near(me, x - 100, y, 220)) return;
          V['seen' + i] = true; m.unmark('b' + i);
          if (i === V.boatAt) { V.found = true; m.mark('boat', x - 60, y, '渡船'); m.folk(x + 40, y, { name: '渡船', still: true, near: 1, draw: skiff }); m.line('曹洪', '這裡有船！主公快來！'); }
          else m.line('曹洪', '這裡沒有船……');
        });
        if (!V.found) return false;
        const [bx, by] = BANKS[V.boatAt];
        return m.near(me, bx - 60, by, 220) && m.near(cao, bx - 60, by, 260);
      },
    },
    { // 4. 得夜遁去
      enter(m, w) {
        const V = m.vars;
        V.boatT = w.t - V.t3;
        m.done('boat'); m.unmark('boat');
        rout(m, w, V.foes, [800, 2500]); V.xu.untargetable = true; V.xu.home = [800, 2500];
        m.card('從弟洪以馬與太祖，得夜遁去。', '《武帝紀》');
        m.after(6, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const V = m.vars;
    if (V.cao) {
      if (!V.cao.alive) { m.lose('曹操陣亡'); return; }
      if (!w.player.alive) { m.lose('曹洪陣亡'); return; }
      // 受傷的曹操：跟著曹洪走，不主動打
      const c = V.cao, I = c.input;
      I.target = null; I.engage = false;
      if (SG.gd(c.x, c.y, w.player.x, w.player.y) > 140) I.moveTo = [w.player.x - 80 * (w.player.f || 1), w.player.y + 40]; else I.moveTo = null;
      return;
    }
    if (!w.player.alive) { m.lose('曹操陣亡'); return; }
    if (V.hong) allyTick(w, V.hong, w.player);
  },
};

// 渡船：靠在岸邊的小船
function skiff(ctx, f, T) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y + Math.sin(T * 2) * 2);
  poly(ctx, [[-60, -10], [50, -10], [64, -20], [40, 6], [-50, 6]], '#6e4a2c', 2);
  ctx.strokeStyle = '#3a2a18'; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(10, -10); ctx.lineTo(30, -60); ctx.stroke();
  ctx.restore();
}
